import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./home";
import Services from "./Services";
import Extraordinary from "./Extraordinary";
import Contact from "./Contact";
import "./App.css";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Router>
      <div className="App">
        {/* Navigation Bar */}
        <nav className="navbar">
          <div className="logo">
            <Link to="/">Dr. Sunil Kumar Singh Bhadouriya</Link>
          </div>
          <div className={`nav-links ${menuOpen ? "active" : ""}`}>
            <Link to="/services" onClick={() => setMenuOpen(false)}>
              Services
            </Link>
            <Link to="/extraordinary" onClick={() => setMenuOpen(false)}>
              you are Not Ordinary
            </Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>
              How to Reach
            </Link>
            {/* Clickable Phone Button in Navbar */}
            <a href="tel:9910860360" className="btn-book">
              📞 Book Appointment
            </a>
          </div>
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/extraordinary" element={<Extraordinary />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        <footer className="footer">
          <p>© 2025 Dr. Sunil Kumar Singh Bhadouriya. All Rights Reserved.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
